export const payouts = {
  main: "Payouts",
};
